<template>
  <div
    class="moow-master-container play-background"
    v-loading.fullscreen="loading"
    element-loading-text="Saving Data ..."
    element-loading-spinner="el-icon-loading"
  >
    <nav-basic :progress="50" title></nav-basic>
    <div class="container">
      <b-row class="step-header">
        <p class="moow-header">Amenities</p>
      </b-row>
      <b-row>
        <b-col md="6" class="pt-2 form-container amenities-form">
          <md-card class="island-card pr-3">
            <md-card-content>
              <listing-amenities ref="amenitiesReference" :useStoreValuesForPrePopulation="true"></listing-amenities>
            </md-card-content>
          </md-card>

          <b-row class="step-navigator-buttons">
            <b-col style="text-align:left;padding:0">
              <md-button @click="prev()" class="md-primary">
                <md-icon>arrow_back</md-icon>Back
              </md-button>
            </b-col>
            <b-col style="text-align:right;padding:0">
              <md-button @click="next" class="md-primary play-cta-button makeup">Next</md-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="5" offset-md="1">
          <md-card>
            <md-card-header>
              <div class="moow-subheader">Providing the essentials helps guests feel at home</div>
            </md-card-header>

            <md-card-content>
              <p
                class="moow-info-txt"
              >Property value can vary significantly depending on its added features and amenities.</p>
              <p
                class="moow-info-txt"
              >Think about the type of guests that your're trying to attract and adapt your rentals' amenities to their needs. Guests staying for 30 days or longer are not tourists. They are more likely people in-between places living their day-to-day lives. They will most likely be setting up their home office in your rental.
              </p>
              <p class="moow-info-txt"> Go through the list of Amenities carefully and select features that apply to your property.</p>
            </md-card-content>
          </md-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Amenities from "../components/listingComponents/listingAmenities.vue";
import { updateListingParts } from "../listingFunctions.js";
export default {
  name: "basic5",
  components: {
    "listing-amenities": Amenities
  },
  data() {
    return {
      loading: false
    };
  },
  created() {
    //this.divideAmenitiesToSections()
  },
  computed: {
    techDet() {
      return this.$store.getters.techDet;
    }
  },
  methods: {
    setSelectedAmanitiesToStoreModel() {
      this.$store.getters.techDet.amenities = this.$refs.amenitiesReference.getSelectedAmenities();
      this.$store.getters.techDet.parking.payment = this.$refs.amenitiesReference.getParkingPayment();
      this.$store.getters.techDet.parking.placement = this.$refs.amenitiesReference.getParkingPlacement();
    },
    leavePage(from, to) {
      this.$store.dispatch("visitPage", from);
      this.$router.push({
        name: to
      });
    },
    getGeoBoundingBoxFinal(location) {
      try {
        return location.geoBoundingBox;
      } catch (err) {
        return undefined;
      }
    },
    getEhrCodeFinal(location) {
      try {
        return location.ehrBuildCode;
      } catch (err) {
        return undefined;
      }
    },
    getInAdsOidFinal(location) {
      try {
        return location.inAdsOid;
      } catch (err) {
        return undefined;
      }
    },
    getEhakFinal(location) {
      try {
        return location.ehak;
      } catch (err) {
        return undefined;
      }
    },
    getLestCoordsFinal(location) {
      try {
        return location.lestCoords;
      } catch (err) {
        return undefined;
      }
    },
    getFormattedAdFinal(location) {
      try {
        return location.address.formattedAD;
      } catch (err) {
        return "";
      }
    },
    getNeighFinal(location) {
      try {
        return location.address.neighbourhood;
      } catch (err) {
        return sessionStorage.getItem("neighbourhood");
      }
    },
    getMuniFinal(location) {
      try {
        var muni = location.address.municipality;
        let indexOfVald = location.address.municipality
          .toLowerCase()
          .indexOf("vald");
        if (indexOfVald == -1) return muni;
        else {
          return muni.substring(-1, indexOfVald).trim();
        }
      } catch (err) {
        let muniFromSession = sessionStorage.getItem("municipality");
        if (muniFromSession) {
          let indexOfVald = sessionStorage
            .getItem("municipality")
            .toLowerCase()
            .indexOf("vald");
          if (indexOfVald == -1) {
            return muniFromSession;
          } else {
            return muniFromSession.substring(-1, indexOfVald).trim();
          }
        }
      }
      return "";
    },
    commitAddressFromSessionToStore() {
      let locServiceLocation = JSON.parse(
        sessionStorage.getItem("locationServiceLoc")
      );
      let confirmedLocation = {
        address: {
          country: sessionStorage.getItem("country"),
          county: sessionStorage.getItem("county"),
          municipality: this.getMuniFinal(locServiceLocation),
          neighbourhood: this.getNeighFinal(locServiceLocation),
          street: sessionStorage.getItem("street"),
          number: sessionStorage.getItem("number"),
          apartNumber: sessionStorage.getItem("apartNumber"),
          formattedAD: this.getFormattedAdFinal(locServiceLocation)
        },
        geoCoords: [
          {
            lat: this.getLatitudeFinal(),
            lng: this.getLongitudeFinal()
          }
        ],
        lestCoords: this.getLestCoordsFinal(locServiceLocation),
        geoBoundingBox: this.getGeoBoundingBoxFinal(locServiceLocation),
        ehrBuildCode: this.getEhrCodeFinal(locServiceLocation),
        inAdsOid: this.getInAdsOidFinal(locServiceLocation),
        ehak: this.getEhakFinal(locServiceLocation)
      };
      this.$store.commit("UPDATE_LOCATION_ENTIRE", confirmedLocation);
    },
    getLatitudeFinal() {
      try {
        let fromSession = sessionStorage.getItem("latitude");
        if (fromSession && fromSession != "") return fromSession;
        else return locServiceLocation.geoCoords[0].lat;
      } catch (err) {
        return "";
      }
    },
    getLongitudeFinal() {
      try {
        let fromSession = sessionStorage.getItem("longitude");
        if (fromSession && fromSession != "") return fromSession;
        else return locServiceLocation.geoCoords[0].lng;
      } catch (err) {
        return "";
      }
    },
    next() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          sessionStorage.setItem("sceneStatus", 0);
          this.leavePage("BASIC5", "addListing1");
        } else {
          this.notifyError("Notification", "Something is missing");
        }
      });
    },
    prev() {
      this.setSelectedAmanitiesToStoreModel();
      this.$store.commit("UPDATE_TECHDET", this.techDet);
      this.leavePage("BASIC5", "basic4");
    },
    saveAndExit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          this.leavePage("BASIC5", "dashboard");
        } else {
          this.notifyError("Notification", "Something is missing");
        }
      });
    },
    save() {
      this.setSelectedAmanitiesToStoreModel();
      this.commitAddressFromSessionToStore(); // by now the location request must have responded
      this.$store.commit("UPDATE_TECHDET", this.techDet);
      updateListingParts(this.createUpdateParts()).catch(err => {});
    },
    createUpdateParts() {
      return {
        techDet: this.techDet,
        location: this.$store.getters.location
      };
    }
  },
  props: {
    data: {
      type: Object,
      required: false
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../assets/styles/add-steps.css";
@import "../assets/styles/global.css";

#desc {
  background-color: rgb(240, 229, 229);
}

.checkBtn {
  opacity: 0;
  outline: none;
  position: absolute;
  margin: 0;
  left: -999px;
}

.button {
  margin: 10px;
  width: 150px;
  height: 40px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: #1f8efa;
  border-radius: 4px;
  border: solid 1px #1f8efa;
  background-color: #ffffff;
}

p {
  color: #757575;
  text-align: left;
  font-size: 14px;
}

.row {
  border-bottom: 1px solid #ededed;
  padding-bottom: 10px;
  padding-top: 10px;
}

.form-group {
  margin-bottom: 0px;
}

label {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/basic5.vue